import React from 'react';
import CalculatorDK from './components/dk';
import CalculatorES from './components/es';
import CalculatorPL from './components/pl';
import CalculatorPLCreditLine from './components/pl-credit-line';
import CalculatorESMPL from './components/es-mpl';
import CalculatorESMPLV2 from './components/es-mpl-v2';
import CalculatorFI from './components/fi';
import CalculatorFICORP from './components/fi-corp';
import CalculatorDKCORP from './components/dk-corp';
import { Visibility } from '../../../../../../../types/common-types';

export interface Props {
  id: string;
  visibility?: Visibility;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  extra: any;
  type?: string;
  countryCode: string;
  onSubmit: (id: string) => void;
  onChange: (
    value: {
      id: string;
      value: object;
      error: boolean;
    },
    callback?: () => void
  ) => void;
}
const market = process.env.MARKET;
const Calculator: React.FC<Props> = props => {
  switch (props.countryCode) {
    case 'ES':
      // eslint-disable-next-line react/jsx-props-no-spreading
      if (props.type === 'mpl') return <CalculatorESMPL {...props} />;
      // eslint-disable-next-line react/jsx-props-no-spreading
      if (props.type === 'mpl-v2') return <CalculatorESMPLV2 {...props} />;
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <CalculatorES {...props} />;
    case 'PL':
      // eslint-disable-next-line react/jsx-props-no-spreading
      if (props.type === 'creditLine')
        return <CalculatorPLCreditLine {...props} />;
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <CalculatorPL {...props} />;
    case 'DK':
      // eslint-disable-next-line react/jsx-props-no-spreading
      if (market === 'DK_CORP') return <CalculatorDKCORP {...props} />;
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <CalculatorDK {...props} />;
    case 'FI':
      // eslint-disable-next-line react/jsx-props-no-spreading
      if (market === 'FI_CORP') return <CalculatorFICORP {...props} />;
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <CalculatorFI {...props} />;
    default:
      return null;
  }
};

export default Calculator;
